import axios from 'axios';
import Cookies from 'js-cookie';


const token = Cookies.get('token');
const adminToken = Cookies.get('adminToken');
const paymobSTESTK = process.env.REACT_APP_PAYMOB_SECRET_TESTKEY;
const paymobSK = process.env.REACT_APP_PAYMOB_SECRET_KEY;


const apiAxiosAdmin = axios.create({
    baseURL: process.env.REACT_APP_MASAR_API_URL,
    headers: {
        'Authorization': `Bearer ${adminToken}`,
        "Content-Type": 'multipart/form-data'
    }
});

const apiAxiosAdminJSON = axios.create({
    baseURL: process.env.REACT_APP_MASAR_API_URL,
    headers: {
        'Authorization': `Bearer ${adminToken}`,
        "Content-Type": 'application/json'
    }
});


// Modify Admin dashbord Data
export const editAdminData = (data) => apiAxiosAdmin.patch('/users/moderators', data)

/// Modirators ///
// add Modirators Form
export const addModiratorsForm = (data) => apiAxiosAdmin.post('/users/moderators', data)
// Modify Modirators Data
export const editModiratorsData = (id, data) => apiAxiosAdmin.patch(`/users/moderators/${id}`, data)

/// Books ///
// Add book admin dashbord Data
export const addBooksform = (data) => apiAxiosAdmin.post('/library/books', data)
// Add book admin dashbord Data
export const editBooksform = (id, data) => apiAxiosAdmin.patch(`/library/books/${id}`, data)
// Add book admin dashbord Data
export const deleteBooksform = (id) => apiAxiosAdmin.delete(`/library/books/${id}`)

/// Library Categories ///
// Add Library Categories admin dashbord Data
export const addLibCategoryform = (data) => apiAxiosAdminJSON.post('/library/categories', data)
// Add Library Categories admin dashbord Data
export const editLibCategoryform = (id, data) => apiAxiosAdminJSON.patch(`/library/categories/${id}`, data)
// Add Library Categories admin dashbord Data
export const deleteLibCategoryform = (id) => apiAxiosAdmin.delete(`/library/categories/${id}`)

/// Orders ///
// Modify Orders in Admin dashbord Data
export const editOrderOffer = (orderId, data) => apiAxiosAdmin.patch(`/orders/admins/${orderId}`, data)

/// Profile Works ///
// Add work image in admin dashbord Data
export const addWorkform = (data) => apiAxiosAdmin.post('/works', data)

/// Advanced Services ///
export const editAdvServicesform = (serviceId, data) => apiAxiosAdmin.patch(`/services/${serviceId}`, data)
/// Admin Offers ///
export const editAdminOffersform = (offerId, data) => apiAxiosAdmin.patch(`/offers/${offerId}`, data)
// Edit Advanced services in admin dashbord Data
export const addAdvServicesform = (data) => apiAxiosAdmin.post(`/services`, data)
// Add Advanced services in admin dashbord Data
export const AddadminOffersform = (data) => apiAxiosAdmin.post(`/offers`, data)
// Add Offers in admin dashbord Data


const api = axios.create({
    baseURL: process.env.REACT_APP_MASAR_API_URL,
    headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json'
    }
});

const apiAxiosUser = axios.create({
    baseURL: process.env.REACT_APP_MASAR_API_URL,
    headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": 'multipart/form-data'
    }
});

const apiAxiosUserPayment = axios.create({
    baseURL: process.env.REACT_APP_PAYMOB_BASE_URL,
    headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": 'application/json'
    }
    // body: {
    //     "auth_token": "Your Auth Token",
    //     "merchant_order_id": "your merchant order ID",
    //     "order_id": "Your Order ID"
    // }
});

export const userLogIn = (data) => api.post(`${process.env.REACT_APP_MASAR_API_URL}/auth/login`, data)
// Users
//// User add service Book
export const userServiceReqest = (data) => apiAxiosUser.post('/orders', data)
//// User patch user info
export const userDataUpdate = (data) => apiAxiosUser.patch('/users/profile', data)
//// User patch user info
export const userOfferUpdate = (orderId, data) => apiAxiosUser.patch(`/orders/${orderId}`, data)
//// User patch user info
export const transactionInquiry = (data) => apiAxiosUserPayment.post(`/api/ecommerce/orders/transaction_inquiry`, data)

export const deleteBooksFav = (id) => apiAxiosUser.delete(`/library/favorite/books/${id}`)
export const addBooksFav = (id) => apiAxiosUser.post(`/library/favorite/books/${id}`)


// FOR TEST
const apiAxiosPaymobTest = axios.create({
    baseURL: process.env.REACT_APP_PAYMOB_BASE_URL,
    headers: {
        'Authorization': `Token ${paymobSTESTK}`,
        "Content-Type": 'application/json'
    }
});

//// FOR LIVE
const apiAxiosPaymob = axios.create({
    baseURL: process.env.REACT_APP_PAYMOB_BASE_URL,
    headers: {
        'Authorization': `Token ${paymobSK}`,
        "Content-Type": 'application/json'
    }
});

//// Create intention
export const masarPaymobInt = (data) => apiAxiosPaymob.post('/v1/intention/', data)
export const masarPaymobIntTest = (data) => apiAxiosPaymobTest.post('/v1/intention/', data)




export default apiAxiosUser;
